// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { Client } from '../_models/client.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum ClientActionTypes {
  ClientOnServerCreated = '[Clients] Client On Server Created',
  ClientCreated = '[Clients] Client Created',
  ClientOnServerUpdated = '[Clients] Client On Server Updated',
  ClientUpdated = '[Clients] Client Updated',
  ClientOnServerDeleted = '[Clients] Client On Server Deleted',
  ClientDeleted = '[Clients] Client Deleted',
  ClientsPageRequested = '[Clients] Clients Page Requested',
  ClientsPageLoaded = '[Clients] Clients Page Loaded',
  ClientsPageCancelled = '[Clients] Clients Page Cancelled',
  ClientsPageToggleLoading = '[Clients] Clients Page Toggle Loading',
  ClientsActionToggleLoading = '[Clients] Clients Action Toggle Loading',
  ThrowClientError = '[Clients] Throw Error',
  FireClientSuccess = '[Clients] Fire Success',
}

export class ClientOnServerCreated implements Action {
  readonly type = ClientActionTypes.ClientOnServerCreated;
  constructor(public payload: { client: Client }) {}
}

export class ClientCreated implements Action {
  readonly type = ClientActionTypes.ClientCreated;
  constructor(public payload: { client: Client }) {}
}

export class ThrowClientError implements Action {
  readonly type = ClientActionTypes.ThrowClientError;
  constructor(public payload: { error: any }) {}
}

export class FireClientSuccess implements Action {
  readonly type = ClientActionTypes.FireClientSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class ClientOnServerUpdated implements Action {
  readonly type = ClientActionTypes.ClientOnServerUpdated;
  constructor(
    public payload: {
      partialClient: Update<Client>;
      client: Client;
    },
  ) {}
}
export class ClientUpdated implements Action {
  readonly type = ClientActionTypes.ClientUpdated;
  constructor(
    public payload: {
      partialClient: Update<Client>;
      client: Client;
    },
  ) {}
}

export class ClientOnServerDeleted implements Action {
  readonly type = ClientActionTypes.ClientOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class ClientDeleted implements Action {
  readonly type = ClientActionTypes.ClientDeleted;
  constructor(public payload: { id: number }) {}
}

export class ClientsPageRequested implements Action {
  readonly type = ClientActionTypes.ClientsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class ClientsPageLoaded implements Action {
  readonly type = ClientActionTypes.ClientsPageLoaded;
  constructor(public payload: { clients: Client[]; totalCount: number; page: QueryParamsModel }) {}
}

export class ClientsPageCancelled implements Action {
  readonly type = ClientActionTypes.ClientsPageCancelled;
}

export class ClientsPageToggleLoading implements Action {
  readonly type = ClientActionTypes.ClientsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ClientsActionToggleLoading implements Action {
  readonly type = ClientActionTypes.ClientsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type ClientActions =
  | ClientCreated
  | ClientUpdated
  | ClientDeleted
  | ClientOnServerCreated
  | ClientOnServerUpdated
  | ClientOnServerDeleted
  | ClientsPageLoaded
  | ClientsPageCancelled
  | ClientsPageToggleLoading
  | ClientsPageRequested
  | ThrowClientError
  | FireClientSuccess
  | ClientsActionToggleLoading;
